export default class Device {

	constructor (data) {
		this.id = parseInt(data.id)
		this.uid = data.uid
		this.name = data.name
		this.phone = data.phone
		this.group_id = parseInt(data.group_id)
	}
}



// WEBPACK FOOTER //
// ./src/classes/Device.js